import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ETextSize, EToggleSize } from '../../common/enums/index.enum';
  import CustomToggle from './CustomToggle.vue';
  import CustomHeadline from './CustomHeadline.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomHeadlineWithToggle',
  props: {
    active: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    noSpacing: { type: Boolean, default: false },
    size: { default: ETextSize.LG },
    text: null,
    toggleSize: { default: EToggleSize.MD }
  },
  emits: ["undefined"],
  setup(__props: any, { emit }: { emit: ({
    (e: `update:active`, value: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { active: boolean, border: boolean, clickable: boolean, disabled: boolean, indeterminate: boolean, noSpacing: boolean, size: ETextSize, text: string, toggleSize: EToggleSize }

  
  

  function updateActive(): void {
    if(props.disabled) {
      return;
    }
    emit(`update:active`, !props.active);
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ccn-headline-with-checkbox", [
      { 'ccn-headline-with-checkbox--disabled': __props.disabled },
      { 'ccn-headline-with-checkbox--no-spacing': __props.noSpacing },
    ]])
  }, [
    _createVNode(CustomHeadline, {
      clickable: __props.clickable,
      "no-spacing": "",
      size: __props.size,
      text: __props.text,
      onClick: updateActive
    }, null, 8, ["clickable", "size", "text"]),
    _createVNode(CustomToggle, {
      active: __props.active,
      disabled: __props.disabled,
      indeterminate: __props.indeterminate,
      size: __props.toggleSize,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`update:active`, $event)))
    }, null, 8, ["active", "disabled", "indeterminate", "size"])
  ], 2))
}
}

})